import React from 'react'
import { DashboardRouteImport } from './Import'
const { RoutesMap, Dashboard, Profile, BuddyList } = DashboardRouteImport

const DashboardRoute = () => {
    return [
        {
            path: RoutesMap.DASHBOARD.path,
            element: <Dashboard />
        },
        {
            path: RoutesMap.PROFILE.path,
            element: <Profile />
        },
        {
            path: RoutesMap.BUDDIES.path,
            element: <BuddyList />
        },
    ]
}

export default DashboardRoute;